<template>
  <base-material-card :icon="resource.icon" :title="title">
    <va-list :filters="filters" hide-header>
      <template #actions>
        <va-bulk-action-button
          :label="$t('users.enable')"
          icon="mdi-publish"
          color="success"
          :action="{ active: true }"
          text
        ></va-bulk-action-button>
        <va-bulk-action-button
          :label="$t('users.disable')"
          icon="mdi-download"
          color="orange"
          :action="{ active: false }"
          text
        ></va-bulk-action-button>
      </template>
      <va-data-table :fields="fields" show-expand disable-delete>
        <template #[`item.actions`]="{ item }">
          <CustomDeleteButton :item="item" icon></CustomDeleteButton>
        </template>
      </va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
import CustomDeleteButton from '../../components/CustomDeleteButton.vue';

export default {
  components: { CustomDeleteButton },
  props: {
    title: {
      type: String,
      default: '',
    },
    resource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { source: 'title', sortable: true },
        { source: 'isbn', sortable: true },
        { source: 'publisher', sortable: true },
        {
          source: 'updated',
          type: 'date',
          sortable: true,
        },
      ],
      filters: [
        'title',
        {
          source: 'resourceType',
          type: 'select',
          attributes: {
            multiple: true,
          },
        },
      ],
    };
  },
};
</script>
